
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guestpass/[slugCoach]",
      function () {
        return require("private-next-pages/guestpass/[slugCoach]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guestpass/[slugCoach]"])
      });
    }
  